import type { UsagePeriod } from '../../../queries/queryOptions';

/**
 * The period presets the Dashboard and Livepoint's usage pages offer (the
 * customer's usage page has none: it covers the account's whole history),
 * and the UK days each one covers. Every day is a UK (Europe/London) day, as
 * the server counts them, so just after midnight in summer is already the
 * next day.
 */

export const PERIOD_PRESETS = [
  { days: 7, label: 'Last 7 days' },
  { days: 30, label: 'Last 30 days' },
  { days: 90, label: 'Last 90 days' },
] as const;

const londonDayFormat = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/London',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const DAY_MS = 86_400_000;

/** The `days` UK days ending today, today included. */
export function lastDays(days: number, now = new Date()): UsagePeriod {
  const to = londonDayFormat.format(now);
  const from = new Date(Date.parse(`${to}T00:00:00Z`) - (days - 1) * DAY_MS).toISOString().slice(0, 10);
  return { from, to };
}
